import { useScreenLayout } from './ScreenLayoutProvider';
import { ContentContainer } from './styled';
export function Content(props) {
    const { children } = props;
    const { sidebar } = useScreenLayout();
    return <ContentContainer $sidebarOpen={sidebar.state}>{children}</ContentContainer>;
}
